import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import LoopRoundedIcon from '@mui/icons-material/LoopRounded';
import Button from '@mui/material/Button';
import color from 'color';
import { useCallback } from 'react';
import { setPendingAvatar } from '../../redux/actions/selfAvatarActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { ALL_HUMAN_AVATAR_COLOR_TYPES, HUMAN_AVATAR_COLOR_TYPES } from '../../types/avatarTypes';
import { AvatarColorControl } from './avatarColors/avatarColorControl';
import { getRandomHumanAvatarProperties } from './avatarRandomUtils';
function getOtherColor(currentColorType, pendingAvatarProperties) {
    switch (currentColorType) {
        case 'hair': {
            return pendingAvatarProperties.colors.skin;
        }
        case 'skin': {
            return pendingAvatarProperties.colors.hair;
        }
    }
}
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 3px;
  gap: 5px;
`;
export const AvatarGeneralControlsContainer = () => {
    const dispatch = useAppDispatch();
    // TODO: Improve this inefficient selector:
    const pendingAvatarProperties = useAppSelector((state) => state.selfAvatar.avatar?.pendingAvatar.type === 'custom' &&
        state.selfAvatar.avatar?.pendingAvatar.avatar.properties);
    const onClickRandomize = useCallback(() => {
        dispatch(setPendingAvatar({ set: 'human', properties: getRandomHumanAvatarProperties() }));
    }, [dispatch]);
    if (!pendingAvatarProperties) {
        return null;
    }
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(Button, { title: 'Randomize All', onClick: onClickRandomize, startIcon: _jsx(LoopRoundedIcon, {}), variant: 'outlined', children: "Randomize All" }), ALL_HUMAN_AVATAR_COLOR_TYPES.map((colorType) => {
                const colorTypeDefinition = HUMAN_AVATAR_COLOR_TYPES[colorType];
                const otherColorLuminosity = color(getOtherColor(colorType, pendingAvatarProperties)).luminosity();
                return (_jsx(AvatarColorControl, { colorTypeDefinition: colorTypeDefinition, currentColor: pendingAvatarProperties.colors[colorTypeDefinition.colorType] || '0xffffff', otherColorLuminosity: otherColorLuminosity }, colorType));
            })] }));
};
